export function getGenders() {
    return [{ _id: "M", name: "M" }, { _id: "F", name: "F" }];
}
